import { createFileRoute } from '@tanstack/react-router';
import { TranslationsPage } from '@/features/translations/TranslationsPage';

interface TranslationsSearchParams {
  language_id?: number;
  page?: number;
  page_size?: number;
  search?: string;
  new_only?: boolean;
}

export const Route = createFileRoute('/_app/translations')({
  component: TranslationsPage,
  validateSearch: (search: Record<string, unknown>): TranslationsSearchParams => {
    return {
      language_id: search.language_id ? Number(search.language_id) : undefined,
      page: search.page ? Number(search.page) : undefined,
      page_size: search.page_size ? Number(search.page_size) : undefined,
      search: search.search as string | undefined,
      new_only: search.new_only === 'true' || search.new_only === true,
    };
  },
});
